// extracted by mini-css-extract-plugin
export default {"spinner-container":"qUZnEC","spinnerContainer":"qUZnEC","spinner":"i4DZVO"};